import { TaxDetails } from "./TaxDetails";
import { TaxDetailsProvider } from "./TaxDetailsProvider";

/**
 * Entry point for the Tax Details section: binds the provider to the view.
 */
const TaxDetailsSection = () => {
  return (
    <TaxDetailsProvider>
      <TaxDetails />
    </TaxDetailsProvider>
  );
};

export { TaxDetailsSection };
